import React, { Component } from 'react';

class Producto extends Component {
    constructor(props) {
        super(props)
    }
    /**
     * 
     */
    render() {
        let productos = JSON.parse(JSON.stringify(this.props.data.accountData.GET_PRODUCTO));
        let productoId = this.props.data.ProductoId;
        let producto = productos.find(x => x.Id == productoId);

        return (
            <div className="row bottom-separator-xs">
                <div className="col-xs-12">
                    <div className="row">
                        <div className="col-xs-12">
                            <label className="label-primary">Producto</label>
                        </div>
                    </div>
                    <label className="label-secondary" >{producto.Descripcion}</label>
                </div>
            </div>
        );
    }
}

export default Producto;